import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../../Assets/images/logo.png";
import { Accordion, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import slice from "../../../store/auth/slice";
import { disconnectSocket } from "../../../helpers/socket";
const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  const handleLogout = async () => {
    try {
      localStorage.clear();
      console.log("logout run");
      disconnectSocket();
      dispatch(slice.actions.logoutUser());
      toast.success("Logout Succesfully");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.log(err, "error=====><");
      if (err && err.data && err.data.message) {
        localStorage.clear();
        toast.error(err.data.message);
      }
    }
  };
  return (
    <div
      className={`${styles.sidebar} ${
        sidebar && styles.active
      } pt-4 position-fixed`}
    >
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="white"
          />
        </svg>
      </Button>
      <div className={`${styles.top} top text-center px-2 `}>
        <Link
        onClick={handleSidebar}
         to="/" className={`${styles.logo}  logo`}>
          <span
            className="themeClr d-flex justify-content-center fw-bold"
            style={{ fontSize: 30 }}
          >
            <img src={logo} alt="" className="img-fluid" />
          </span>
        </Link>
      </div>
      <Accordion className={`${styles.linkWrpper} linkWrpper pt-2 px-2`}>
        <ul className="list-unstyled ps-0 mb-0">
          <li className="py-1">
            <NavLink
        onClick={handleSidebar}

              to="/dashboard"
              className={`${styles.link} ${
                pageActive.includes("/dashboard") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.8 1H2.75C2.521 1 2.324 1 2.15 1.041C1.88064 1.10536 1.63435 1.24305 1.43843 1.43879C1.24251 1.63453 1.10461 1.88069 1.04 2.15C1 2.324 1 2.52 1 2.75V5.25C1 5.479 1 5.676 1.041 5.85C1.10536 6.11936 1.24305 6.36565 1.43879 6.56157C1.63453 6.75749 1.88069 6.89539 2.15 6.96C2.324 7 2.52 7 2.75 7H5.25C5.479 7 5.676 7 5.85 6.959C6.11936 6.89464 6.36565 6.75695 6.56157 6.56121C6.75749 6.36547 6.89539 6.11931 6.96 5.85C7 5.676 7 5.48 7 5.25V2.75C7 2.521 7 2.324 6.959 2.15C6.89464 1.88064 6.75695 1.63435 6.56121 1.43843C6.36547 1.24251 6.11931 1.10461 5.85 1.04C5.676 1 5.48 1 5.25 1H5.2H2.8ZM2.383 2.014C2.426 2.004 2.493 2 2.8 2H5.2C5.508 2 5.574 2.003 5.617 2.014C5.70683 2.03548 5.78895 2.08143 5.85426 2.14674C5.91957 2.21205 5.96552 2.29417 5.987 2.384C5.997 2.426 6 2.492 6 2.8V5.2C6 5.508 5.997 5.574 5.986 5.617C5.96452 5.70683 5.91857 5.78895 5.85326 5.85426C5.78795 5.91957 5.70583 5.96552 5.616 5.987C5.575 5.996 5.509 6 5.2 6H2.8C2.492 6 2.426 5.997 2.383 5.986C2.29317 5.96452 2.21105 5.91857 2.14574 5.85326C2.08043 5.78795 2.03448 5.70583 2.013 5.616C2.004 5.575 2 5.509 2 5.2V2.8C2 2.492 2.003 2.426 2.014 2.383C2.03548 2.29317 2.08143 2.21105 2.14674 2.14574C2.21205 2.08043 2.29417 2.03448 2.384 2.013M9.8 1H9.75C9.521 1 9.324 1 9.15 1.041C8.88064 1.10536 8.63435 1.24305 8.43843 1.43879C8.24251 1.63453 8.10461 1.88069 8.04 2.15C8 2.324 8 2.52 8 2.75V5.25C8 5.479 8 5.676 8.041 5.85C8.10537 6.11936 8.24305 6.36565 8.43879 6.56157C8.63453 6.75749 8.88069 6.89539 9.15 6.96C9.324 7 9.52 7 9.75 7H12.25C12.479 7 12.676 7 12.85 6.959C13.1194 6.89464 13.3657 6.75695 13.5616 6.56121C13.7575 6.36547 13.8954 6.11931 13.96 5.85C14 5.676 14 5.48 14 5.25V2.75C14 2.521 14 2.324 13.959 2.15C13.8946 1.88064 13.757 1.63435 13.5612 1.43843C13.3655 1.24251 13.1193 1.10461 12.85 1.04C12.676 1 12.48 1 12.25 1H12.2H9.8ZM9.383 2.014C9.426 2.004 9.493 2 9.8 2H12.2C12.508 2 12.574 2.003 12.617 2.014C12.7068 2.03548 12.789 2.08143 12.8543 2.14674C12.9196 2.21205 12.9655 2.29417 12.987 2.384C12.997 2.426 13 2.492 13 2.8V5.2C13 5.508 12.996 5.574 12.986 5.617C12.9645 5.70683 12.9186 5.78895 12.8533 5.85426C12.788 5.91957 12.7058 5.96552 12.616 5.987C12.574 5.997 12.508 6 12.2 6H9.8C9.492 6 9.426 5.997 9.383 5.986C9.29317 5.96452 9.21105 5.91857 9.14574 5.85326C9.08043 5.78795 9.03448 5.70583 9.013 5.616C9.004 5.575 9 5.509 9 5.2V2.8C9 2.492 9.003 2.426 9.014 2.383C9.03548 2.29317 9.08142 2.21105 9.14674 2.14574C9.21205 2.08043 9.29417 2.03448 9.384 2.013M2.75 8H5.25C5.479 8 5.676 8 5.85 8.041C6.11936 8.10537 6.36565 8.24305 6.56157 8.43879C6.75749 8.63453 6.89539 8.88069 6.96 9.15C7 9.324 7 9.52 7 9.75V12.25C7 12.479 7 12.676 6.959 12.85C6.89464 13.1194 6.75695 13.3657 6.56121 13.5616C6.36547 13.7575 6.11931 13.8954 5.85 13.96C5.676 14 5.48 14 5.25 14H2.75C2.521 14 2.324 14 2.15 13.959C1.88064 13.8946 1.63435 13.757 1.43843 13.5612C1.24251 13.3655 1.10461 13.1193 1.04 12.85C1 12.676 1 12.48 1 12.25V9.75C1 9.521 1 9.324 1.041 9.15C1.10536 8.88064 1.24305 8.63435 1.43879 8.43843C1.63453 8.24251 1.88069 8.10461 2.15 8.04C2.324 8 2.52 8 2.75 8ZM2.8 9C2.492 9 2.426 9.003 2.383 9.014C2.29317 9.03548 2.21105 9.08142 2.14574 9.14674C2.08043 9.21205 2.03448 9.29417 2.013 9.384C2.004 9.425 2 9.491 2 9.8V12.2C2 12.508 2.003 12.574 2.014 12.617C2.03548 12.7068 2.08143 12.789 2.14674 12.8543C2.21205 12.9196 2.29417 12.9655 2.384 12.987C2.426 12.997 2.492 13 2.8 13H5.2C5.508 13 5.574 12.996 5.617 12.986C5.70683 12.9645 5.78895 12.9186 5.85426 12.8533C5.91957 12.788 5.96552 12.7058 5.987 12.616C5.997 12.574 6 12.508 6 12.2V9.8C6 9.492 5.997 9.426 5.986 9.383C5.96452 9.29317 5.91857 9.21105 5.85326 9.14574C5.78795 9.08043 5.70583 9.03448 5.616 9.013C5.575 9.004 5.509 9 5.2 9H2.8ZM9.8 8H9.75C9.521 8 9.324 8 9.15 8.041C8.88064 8.10537 8.63435 8.24305 8.43843 8.43879C8.24251 8.63453 8.10461 8.88069 8.04 9.15C8 9.324 8 9.52 8 9.75V12.25C8 12.479 8 12.676 8.041 12.85C8.10537 13.1194 8.24305 13.3657 8.43879 13.5616C8.63453 13.7575 8.88069 13.8954 9.15 13.96C9.324 14.001 9.521 14.001 9.75 14.001H12.25C12.479 14.001 12.676 14.001 12.85 13.96C13.1192 13.8955 13.3653 13.7577 13.561 13.562C13.7567 13.3663 13.8945 13.1202 13.959 12.851C14 12.677 14 12.48 14 12.251V9.75C14 9.521 14 9.324 13.959 9.15C13.8946 8.88064 13.757 8.63435 13.5612 8.43843C13.3655 8.24251 13.1193 8.10461 12.85 8.04C12.676 8 12.48 8 12.25 8H12.2H9.8ZM9.383 9.014C9.426 9.004 9.493 9 9.8 9H12.2C12.508 9 12.574 9.003 12.617 9.014C12.7068 9.03548 12.789 9.08142 12.8543 9.14674C12.9196 9.21205 12.9655 9.29417 12.987 9.384C12.997 9.426 13 9.492 13 9.8V12.2C13 12.508 12.996 12.574 12.986 12.617C12.9645 12.7068 12.9186 12.789 12.8533 12.8543C12.788 12.9196 12.7058 12.9655 12.616 12.987C12.574 12.997 12.508 13 12.2 13H9.8C9.492 13 9.426 12.996 9.383 12.986C9.29317 12.9645 9.21105 12.9186 9.14574 12.8533C9.08043 12.788 9.03448 12.7058 9.013 12.616C9.004 12.575 9 12.509 9 12.2V9.8C9 9.492 9.003 9.426 9.014 9.383C9.03548 9.29317 9.08142 9.21105 9.14674 9.14574C9.21205 9.08043 9.29417 9.03448 9.384 9.013"
                    fill="currentColor"
                  />
                </svg>
              </span>
              Dashboard
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
        onClick={handleSidebar}

              to="/user"
              className={`${styles.link} ${
                pageActive === "/user" && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_175_315)">
                    <path
                      d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_175_315">
                      <rect width="21" height="21" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Manage Users
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
        onClick={handleSidebar}

              to="/create-ai"
              className={`${styles.link} ${
                pageActive === "/create-ai" && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_175_315)">
                    <path
                      d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_175_315">
                      <rect width="21" height="21" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Create Ai
            </NavLink>
          </li>
          <li className="py-1">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="trasaction"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M12 8v4l2 2" />
                      <path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
                    </g>
                  </svg>
                </span>
                Manage Transaction
              </Accordion.Header>
              <Accordion.Body className="pb-0 pt-2 pe-0">
                <ul className="list-unstyled mb-0">
                  {/* <li className="py-1">
                    <NavLink
                      to="/token-payment"
                      className={`${styles.subLinks} ${
                        pageActive === "/token-payment" && styles.active
                      }  d-flex py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Token Payment
                    </NavLink>
                  </li> */}
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/subscription-payment"
                      className={`${styles.subLinks} ${
                        pageActive === "/subscription-payment" && styles.active
                      }  d-flex align-items-center py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Subscription 
                    </NavLink>
                  </li>
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/user-transaction"
                      className={`${styles.subLinks} ${
                        pageActive === "/user-transaction" && styles.active
                      }  d-flex align-items-center py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      User Transaction
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="py-1">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="character"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M12 8v4l2 2" />
                      <path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
                    </g>
                  </svg>
                </span>
                Manage Character
              </Accordion.Header>
              <Accordion.Body className="pb-0 pt-2 pe-0">
                <ul className="list-unstyled mb-0">
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/public-character"
                      className={`${styles.subLinks} ${
                        pageActive === "/public-character" && styles.active
                      }  d-flex py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Public Character
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>

          {/* <li className="py-1">
            <NavLink
              to="/page"
              className={`${styles.link} ${
                pageActive.includes("/page") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 20H5V4H7V7H17V4H19M12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C13 3.26522 12.8946 3.51957 12.7071 3.70711C12.5196 3.89464 12.2652 4 12 4C11.7348 4 11.4804 3.89464 11.2929 3.70711C11.1054 3.51957 11 3.26522 11 3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2ZM19 2H14.82C14.4 0.84 13.3 0 12 0C10.7 0 9.6 0.84 9.18 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V4C21 3.46957 20.7893 2.96086 20.4142 2.58579C20.0391 2.21071 19.5304 2 19 2Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              Pages
            </NavLink>
          </li> */}
          {/* <li className="py-1">
            <NavLink
              to="/language"
              className={`${styles.link} ${
                pageActive.includes("/language") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_382_12)">
                    <path
                      d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM6.33333 11.3333C6.73333 13.4 7.46667 14.6667 8 14.6667C8.53333 14.6667 9.26667 13.4 9.66667 11.3333H6.33333ZM11.0667 11.3333C10.8667 12.4667 10.5333 13.5333 10.1333 14.3333C11.6667 13.8 13 12.7333 13.8 11.3333H11.0667ZM2.2 11.3333C3 12.7333 4.33333 13.8 5.86667 14.3333C5.46667 13.5333 5.13333 12.4667 4.93333 11.3333H2.2ZM11.2667 10H14.4C14.5333 9.4 14.6667 8.66667 14.6667 8C14.6667 7.33333 14.5333 6.6 14.3333 6H11.2C11.3333 6.66667 11.3333 7.33333 11.3333 8C11.3333 8.66667 11.3333 9.33333 11.2667 10ZM6.13333 10H9.93333C10 9.4 10.0667 8.73333 10.0667 8C10.0667 7.26667 10 6.6 9.93333 6H6.13333C6.06667 6.6 6 7.26667 6 8C6 8.73333 6.06667 9.4 6.13333 10ZM1.66667 10H4.8C4.73333 9.33333 4.73333 8.66667 4.73333 8C4.73333 7.33333 4.73333 6.66667 4.8 6H1.66667C1.46667 6.6 1.33333 7.33333 1.33333 8C1.33333 8.66667 1.46667 9.4 1.66667 10ZM11.0667 4.66667H13.8C13 3.26667 11.6667 2.2 10.1333 1.66667C10.5333 2.46667 10.8667 3.53333 11.0667 4.66667ZM6.33333 4.66667H9.73333C9.33333 2.6 8.6 1.33333 8.06667 1.33333C7.53333 1.33333 6.73333 2.6 6.33333 4.66667ZM2.2 4.66667H4.93333C5.13333 3.53333 5.46667 2.46667 5.86667 1.66667C4.33333 2.2 3.06667 3.26667 2.2 4.66667Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_12">
                      <rect width="16" height="16" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Language
            </NavLink>
          </li>      */}
          <li className="py-1">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="2"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M17.9432 8.60728C17.9148 8.35428 17.6197 8.16396 17.3645 8.16396C16.5399 8.16396 15.808 7.67993 15.501 6.93076C15.1877 6.16361 15.3899 5.26911 16.0043 4.70544C16.1978 4.5285 16.2214 4.23223 16.0592 4.02657C15.6369 3.49054 15.1573 3.00627 14.6334 2.58662C14.4284 2.42221 14.1272 2.4451 13.9494 2.64196C13.413 3.23607 12.4493 3.45683 11.7047 3.14616C10.9301 2.82023 10.4411 2.03502 10.4891 1.1922C10.505 0.927303 10.3113 0.697119 10.0473 0.666371C9.37497 0.588528 8.69672 0.58627 8.02244 0.661078C7.76182 0.68988 7.5683 0.914615 7.57694 1.17617C7.60613 2.01073 7.11167 2.78208 6.34452 3.09634C5.60882 3.39689 4.65189 3.17776 4.11656 2.58888C3.93962 2.39489 3.64374 2.37107 3.43737 2.53197C2.89807 2.95521 2.40758 3.43978 1.98146 3.97146C1.81542 4.17813 1.83994 4.47767 2.0351 4.65523C2.66166 5.22264 2.86367 6.12484 2.53836 6.90094C2.22776 7.64085 1.45952 8.11748 0.580123 8.11748C0.294749 8.1083 0.0916546 8.30003 0.0601279 8.55956C-0.0189612 9.23547 -0.0198175 9.92455 0.0563136 10.606C0.0847265 10.8601 0.38855 11.0488 0.646524 11.0488C1.43041 11.0288 2.18253 11.5138 2.4985 12.2819C2.81291 13.049 2.61052 13.9431 1.99509 14.5076C1.80258 14.6845 1.77798 14.9801 1.94052 15.1855C2.35846 15.7182 2.8386 16.2028 3.36404 16.626C3.57033 16.7921 3.87034 16.7689 4.04915 16.5718C4.58767 15.9763 5.55114 15.7559 6.29276 16.0672C7.06963 16.3923 7.55834 17.1774 7.51062 18.0204C7.49497 18.2853 7.68911 18.5162 7.95215 18.5463C8.29622 18.5865 8.64208 18.6064 8.98903 18.6064C9.3183 18.6064 9.64766 18.5885 9.97702 18.5518C10.2379 18.523 10.4312 18.298 10.4224 18.0364C10.3922 17.2022 10.8878 16.4308 11.654 16.1172C12.3946 15.8147 13.3473 16.036 13.8829 16.6241C14.0608 16.8177 14.3549 16.8412 14.5621 16.6809C15.1004 16.2588 15.59 15.7744 16.018 15.2413C16.1842 15.0351 16.1606 14.7351 15.9644 14.5573C15.3379 13.9902 15.1349 13.0876 15.4602 12.3123C15.7659 11.5824 16.5056 11.0923 17.3012 11.0923L17.4125 11.0952C17.6708 11.1162 17.9081 10.9173 17.9393 10.6538C18.0188 9.97725 18.0197 9.28895 17.9432 8.60728ZM8.99984 14.7951C6.13419 14.7951 3.81126 12.4721 3.81126 9.60655C3.81126 6.74098 6.13427 4.41804 8.99984 4.41804C11.8654 4.41804 14.1884 6.74098 14.1884 9.60655C14.1884 10.5792 13.9203 11.489 13.4545 12.2669L11.1826 9.99492C11.3471 9.6071 11.4339 9.18667 11.4339 8.75277C11.4339 7.9031 11.1029 7.10435 10.5021 6.50363C9.90135 5.90291 9.1026 5.57208 8.25309 5.57208C7.96958 5.57208 7.6874 5.60975 7.4144 5.68409C7.29484 5.71671 7.19706 5.81526 7.16523 5.93506C7.13269 6.05759 7.16935 6.18315 7.2651 6.27897C7.2651 6.27897 8.38675 7.40926 8.76203 7.78447C8.80134 7.82378 8.80127 7.91758 8.79574 7.95137L8.79224 7.97604C8.7544 8.38861 8.68146 8.88385 8.62129 9.07418C8.6132 9.0822 8.60557 9.08897 8.59732 9.09722C8.58868 9.10587 8.58074 9.11419 8.57241 9.12276C8.37959 9.18464 7.87672 9.25844 7.45761 9.29596L7.45769 9.2937L7.43885 9.29845C7.4355 9.29884 7.42927 9.29931 7.42102 9.29931C7.37572 9.29931 7.30908 9.28662 7.24852 9.22613C6.8579 8.83552 5.78023 7.76555 5.78023 7.76555C5.68355 7.66918 5.58438 7.64894 5.51829 7.64894C5.36424 7.64894 5.2263 7.76026 5.18286 7.91992C4.8862 9.01775 5.20069 10.1986 6.0038 11.0018C6.60467 11.6026 7.40351 11.9335 8.25317 11.9335C8.68707 11.9335 9.1075 11.8467 9.49524 11.6822L11.7919 13.9788C10.9856 14.4947 10.0281 14.7951 8.99984 14.7951Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                Settings
              </Accordion.Header>
              <Accordion.Body className="pb-0 pt-2 pe-0">
                <ul className="list-unstyled mb-0">
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/character-setting"
                      className={`${styles.subLinks} ${
                        pageActive.includes("/character-setting") &&
                        styles.active
                      }  d-flex align-items-center py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Character Setting
                    </NavLink>
                  </li>
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/token"
                      className={`${styles.subLinks} ${
                        pageActive === "/token" && styles.active
                      }  d-flex py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Token Package
                    </NavLink>
                  </li>
                  <li className="py-1">
                    <NavLink
        onClick={handleSidebar}

                      to="/subscription-plan"
                      className={`${styles.subLinks} ${
                        pageActive.includes("/subscription-plan") &&
                        styles.active
                      }  d-flex py-1 text-white`}
                    >
                      <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      ></span>
                      Subscription
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="py-1">
            <NavLink
        onClick={handleSidebar}

              to="/requests"
              className={`${styles.link} ${
                pageActive === "/requests" && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_175_315)">
                    <path
                      d="M10.5 11.375C11.4283 11.375 12.3185 11.0062 12.9749 10.3499C13.6313 9.6935 14 8.80326 14 7.875C14 6.94674 13.6313 6.0565 12.9749 5.40013C12.3185 4.74375 11.4283 4.375 10.5 4.375C9.57174 4.375 8.6815 4.74375 8.02513 5.40013C7.36875 6.0565 7 6.94674 7 7.875C7 8.80326 7.36875 9.6935 8.02513 10.3499C8.6815 11.0062 9.57174 11.375 10.5 11.375ZM10.5 11.375C9.10761 11.375 7.77226 11.9281 6.78769 12.9127C5.80312 13.8973 5.25 15.2326 5.25 16.625V19.25M10.5 11.375C11.8924 11.375 13.2277 11.9281 14.2123 12.9127C15.1969 13.8973 15.75 15.2326 15.75 16.625V19.25M11.375 4.375C11.7285 2.919 13.1381 1.75 14.875 1.75C16.7755 1.75 18.3575 3.31625 18.375 5.25C18.3575 7.18375 16.7755 8.75 14.875 8.75M14.875 8.75H14M14.875 8.75C17.752 8.75 20.125 11.1002 20.125 14V15.75M9.625 4.375C9.2715 2.919 7.86188 1.75 6.125 1.75C4.2245 1.75 2.6425 3.31625 2.625 5.25C2.6425 7.18375 4.2245 8.75 6.125 8.75M6.125 8.75H7M6.125 8.75C3.248 8.75 0.875 11.1002 0.875 14V15.75"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_175_315">
                      <rect width="21" height="21" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Requests
            </NavLink>
          </li>
          <li className="py-1" onClick={handleLogout}>
            <NavLink
              className={`${styles.link} ${
                pageActive.includes("/login") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17 16L21 12M21 12L17 8M21 12H7M13 16V17C13 17.7956 12.6839 18.5587 12.1213 19.1213C11.5587 19.6839 10.7956 20 10 20H6C5.20435 20 4.44129 19.6839 3.87868 19.1213C3.31607 18.5587 3 17.7956 3 17V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H10C10.7956 4 11.5587 4.31607 12.1213 4.87868C12.6839 5.44129 13 6.20435 13 7V8"
                    stroke="currentColor"
                    stroke-width="2"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              Log Out
            </NavLink>
          </li>
        </ul>
      </Accordion>
    </div>
  );
};
export default Sidebar;
